import * as partials from "../partials/types";

export const CAMPAINS_LIST = partials.createRequestTypes("CAMPAINS_LIST");
export const LOAD_CAMPAINS_LIST_PAGE = "LOAD_CAMPAINS_LIST_PAGE";

export const CONTRIBUTION = partials.createRequestTypes("CONTRIBUTION");
export const CREATE_CONTRIBUTION = "CREATE_CONTRIBUTION";

export * from "../partials/types";
